export default __webpack_public_path__ + "static/media/Inconsolata-Regular.b8a1c4ac.woff";